import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SubscriptionModel } from './models/subscription-model';

@Injectable({
  providedIn: 'root',
})
export class ApimSubscriptionsService {
  private readonly baseUrl: string = environment.apiBaseUrl.replace('/v1/', '/v3/');

  constructor(private http: HttpClient) {}

  public getSubscriptions(productId: string): Observable<SubscriptionModel[]> {
    return this.http.get<SubscriptionModel[]>(`${this.baseUrl}subscriptions/product/${encodeURIComponent(productId)}`);
  }
}
